import { ViewEnum } from '@/types';
import { LayoutSettings } from './type';
import { marsLayoutSettings } from './mars-layout-settings';

export const viewLayoutSettings: Record<ViewEnum, LayoutSettings> = {
	[ViewEnum.galaxy]: {},
	[ViewEnum.mars]: marsLayoutSettings
}